import type { GameSnapshot } from "../types";

function snapshotVersion(snapshot: GameSnapshot): number {
  return snapshot.initialized ? snapshot.state.stateVersion : -1;
}

export function newestGameSnapshot(
  current: GameSnapshot | undefined,
  incoming: GameSnapshot,
): GameSnapshot {
  if (!current) return incoming;
  return snapshotVersion(incoming) >= snapshotVersion(current) ? incoming : current;
}